export const version = import.meta.env.VITE_VERSION;
